import { FunctionComponent, SVGAttributes } from 'react';

export type IconComponent<AdditionalProps = Record<string, unknown>> = FunctionComponent<
  SVGAttributes<SVGElement> & AdditionalProps
>;

export const IconBase: IconComponent = ({ width, height, viewBox, children, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    width={width}
    height={height}
    fill="currentColor"
    {...rest}
  >
    {children}
  </svg>
);

IconBase.defaultProps = {
  width: '1em',
  height: '1em',
  viewBox: '0 0 32 32',
};
